import { CountryIconProps } from './types';

const GD = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3630)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FFDA44"
      />
      <path
        d="M5.23633 2.08691C7.16219 0.770377 9.49084 -6.10352e-05 11.9998 -6.10352e-05C14.5087 -6.10352e-05 16.8374 0.770377 18.7632 2.08691L11.9998 2.60863L5.23633 2.08691Z"
        fill="#A2001D"
      />
      <path
        d="M12.0004 11.9995L11.2346 11.2336L11.0312 11.5979L12.0004 11.9995Z"
        fill="#0052B4"
      />
      <path
        d="M3.51471 3.51514C-1.17157 8.20142 -1.17157 15.7994 3.51471 20.4858C5.45126 18.5492 7.31375 16.6867 12 12.0004L3.51471 3.51514Z"
        fill="#496E2D"
      />
      <path
        d="M20.4853 3.51587C25.1716 8.20215 25.1716 15.8002 20.4853 20.4865C18.5488 18.5499 16.6863 16.6875 12 12.0012L20.4853 3.51587Z"
        fill="#496E2D"
      />
      <path
        d="M12.0001 16.1741C14.3052 16.1741 16.174 14.3054 16.174 12.0002C16.174 9.69501 14.3052 7.82629 12.0001 7.82629C9.69489 7.82629 7.82617 9.69501 7.82617 12.0002C7.82617 14.3054 9.69489 16.1741 12.0001 16.1741Z"
        fill="#A2001D"
      />
      <path
        d="M11.9996 7.82642L12.9352 10.7059H15.9633L13.5137 12.4859L14.4492 15.3655L11.9996 13.5859L9.54996 15.3655L10.4857 12.4859L8.03613 10.7059H11.064L11.9996 7.82642Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0043 -6.10352e-05H11.9963C8.68444 0.00101709 5.68627 1.34366 3.51562 3.51406H20.485C18.3143 1.34366 15.3161 0.00101709 12.0043 -6.10352e-05Z"
        fill="#A2001D"
      />
      <path
        d="M3.51562 20.4857C5.68716 22.6569 8.68688 23.9998 12.0002 23.9998C15.3136 23.9998 18.3133 22.6569 20.4848 20.4857H3.51562Z"
        fill="#A2001D"
      />
      <path
        d="M12.0006 1.3042L12.1949 1.90204H12.8235L12.315 2.27156L12.5093 2.8694L12.0006 2.49993L11.4921 2.8694L11.6864 2.27156L11.1777 1.90204H11.8063L12.0006 1.3042Z"
        fill="#FFDA44"
      />
      <path
        d="M9.09047 1.3042L9.28477 1.90204H9.91336L9.40481 2.27156L9.59911 2.8694L9.09047 2.49993L8.58197 2.8694L8.77622 2.27156L8.26758 1.90204H8.89617L9.09047 1.3042Z"
        fill="#FFDA44"
      />
      <path
        d="M14.9098 1.3042L15.1041 1.90204H15.7327L15.2241 2.27156L15.4184 2.8694L14.9098 2.49993L14.4013 2.8694L14.5956 2.27156L14.0869 1.90204H14.7155L14.9098 1.3042Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0006 21.1298L12.1949 21.7276H12.8235L12.315 22.0971L12.5093 22.695L12.0006 22.3254L11.4921 22.695L11.6864 22.0971L11.1777 21.7276H11.8063L12.0006 21.1298Z"
        fill="#FFDA44"
      />
      <path
        d="M9.09047 21.1298L9.28477 21.7276H9.91336L9.40481 22.0971L9.59911 22.695L9.09047 22.3254L8.58197 22.695L8.77622 22.0971L8.26758 21.7276H8.89617L9.09047 21.1298Z"
        fill="#FFDA44"
      />
      <path
        d="M14.9098 21.1298L15.1041 21.7276H15.7327L15.2241 22.0971L15.4184 22.695L14.9098 22.3254L14.4013 22.695L14.5956 22.0971L14.0869 21.7276H14.7155L14.9098 21.1298Z"
        fill="#FFDA44"
      />
      <path
        d="M3.65664 11.8019C3.96484 12.2889 3.82 12.9335 3.33301 13.2417C2.84607 13.55 2.20145 13.4051 1.8932 12.9182C1.33515 12.0365 1.65873 10.5967 1.65873 10.5967C1.65873 10.5967 3.09854 10.9203 3.65664 11.8019Z"
        fill="#FFDA44"
      />
      <path
        d="M3.05395 13.3225C3.34209 13.3225 3.57567 13.0889 3.57567 12.8008C3.57567 12.5126 3.34209 12.2791 3.05395 12.2791C2.76581 12.2791 2.53223 12.5126 2.53223 12.8008C2.53223 13.0889 2.76581 13.3225 3.05395 13.3225Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3630">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GD;
